import { Box, Typography } from '@material-ui/core';

function LandingFooter() {
  return (
    <Box
      style={{
        marginTop: 30,
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        direction: 'ltr',
      }}
    >
      <Typography component="span" style={{ fontSize: 18, color: '#bbb' }}>
        Jadwal.io
      </Typography>
    </Box>
  );
}

export default LandingFooter;
